import { Component, Input, OnInit, ViewChild, OnDestroy, ViewChildren, QueryList, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AssetSetting } from './asset-setting.model';
import { AccordionPanelComponent } from 'ngx-bootstrap/accordion';

@Component({
	selector: 'app-asset-generator',
	templateUrl: './asset-generator.component.html',
	styleUrls: ['./asset-generator.component.scss']
})
export class AssetGeneratorComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('assetGeneratorForm', { static: true }) assetGeneratorForm: NgForm;
	@ViewChildren('accordionGroup') accordionGroups: QueryList<AccordionPanelComponent>;
	@ViewChild('nameField', { static: true }) nameField;
	formSubscription: Subscription;
	groupSubscription: Subscription;
	feedUrlFocus;
	fallbackImgUrl: string;
	itemCountFocus;
	cronFrequencyFocus;
	prependToLinkCheck: boolean;
	fallbackImageCheck: boolean;

	assetSettings: Array<AssetSetting> = [];
	selectedGroupIndex = Number(0);

	constructor(private cs: ComponentService, private ref: ChangeDetectorRef) {}

	ngOnInit() {
		this.getAssetSettings();

		if (this.componentData.config.prepend_to_link) {
			this.prependToLinkCheck = true;
		} else {
			this.prependToLinkCheck = false;
		}

		if (this.componentData.config.fallback_image) {
			this.fallbackImageCheck = true;
		} else {
			this.fallbackImageCheck = false;
		}

		this.fallbackImgUrl =
			this.componentData &&
			this.componentData.config &&
			this.componentData.config.fallback_image &&
			this.componentData.config.fallback_image.image_url
				? this.componentData.config.fallback_image.image_url
				: '';

		this.formSubscription = this.assetGeneratorForm.valueChanges
			.pipe(
				tap(() =>
					this.cs.updateDisabledSave(
						(this.assetGeneratorForm.dirty && this.assetGeneratorForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((data) => Boolean(this.assetGeneratorForm.dirty && this.assetGeneratorForm.valid)),
				debounceTime(2000)
			)
			.subscribe(
				(form) => {
					// this.renderWidget()
				},
				(error) => {
					// console.log(`PII: ${JSON.stringify(error)}`);
					this.cs.updateDisabledSave(false);
				},
				() => {}
			);
	}

	ngAfterViewInit() {
		this.updateGroups();
		this.ref.detectChanges();
		this.groupSubscription = this.accordionGroups.changes.subscribe((groups: QueryList<AccordionPanelComponent>) =>
			this.updateGroups()
		);
	}

	ngOnDestroy() {
		this.formSubscription.unsubscribe();
	}

	updateGroups(): void {
		const accordionGroup: AccordionPanelComponent = this.accordionGroups.toArray()[this.selectedGroupIndex];
		accordionGroup.isOpen = !accordionGroup.isOpen;
		accordionGroup.isOpenChange.emit(accordionGroup.isOpen);
		this.ref.detectChanges();
	}

	renderWidget(): void {
		this.cs.updateComponentData(this.componentData);
		this.cs.updatePreviewData();
	}

	onFallbackImgUrlChange($event) {
		this.fallbackImgUrl = $event;

		if (this.fallbackImgUrl && this.fallbackImgUrl.length) {
			this.componentData.config = Object.assign({}, this.componentData.config, {
				fallback_image: {
					image_url: $event
				}
			});
		} else {
			delete this.componentData.config.fallback_image;
		}
	}

	addAssetSetting(event: MouseEvent): void {
		this.componentData.config.mapping_params.push({ token: '', name: '', required: false, fallback: '' });
		this.cs.updateComponentData(this.componentData);
		this.getAssetSettings();
		this.selectedGroupIndex = Number(this.accordionGroups.length);
		this.ref.markForCheck();
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	removeAssetSetting(event: MouseEvent, index: number, assetSetting: AssetSetting): void {
		const settingName = String(assetSetting.key + 1);
		if (confirm(`Are sure you want to delete "Asset token ${settingName}"?`)) {
			this.componentData.config.mapping_params.splice(index, 1);
			this.cs.updateComponentData(this.componentData);
			this.getAssetSettings();
			this.selectedGroupIndex = Number(0);
			event.preventDefault();
		}
	}

	getAssetSettings(): void {
		const rawSettings: Array<any> = this.componentData.config.mapping_params;
		this.assetSettings = [];

		for (let i = 0; i < rawSettings.length; ++i) {
			this.assetSettings.push(
				new AssetSetting({
					key: i,
					order: i,
					token: rawSettings[i].token,
					name: rawSettings[i].name,
					required: rawSettings[i].required,
					fallback: rawSettings[i].fallback
				})
			);
		}
	}

	no_iterator_pathChange() {
		if (this.componentData.config.no_iterator_path) {
			this.componentData.config.iterator_path = 'no_iterator_path';
		} else {
			this.componentData.config.iterator_path = '';
		}
	}

	prependChange() {
		if (!this.prependToLinkCheck) {
			this.componentData.config.prepend_to_link = '';
		}
	}

	fallbackImageCheckChange() {
		if (!this.fallbackImageCheck) {
			this.componentData.config.fallback_image = '';
		}
	}

	checkSingleImage() {
		if (this.componentData.config.item_count == 1) {
			this.componentData.config.single_element = true;
		} else {
			this.componentData.config.single_element = false;
		}
	}
}
